<script>
import Label from "./Label.vue";

export default {
  props: {
    item_key: {
      type: String,
      required: true,
    },
    item_value: {
      required: false,
    },
    item: {
      type: Object,
      required: true,
    },
    submitted: {
      type: Boolean,
      required: true,
    },
    validation: {
      type: Object,
      required: true,
    },
    updateValue: {
      type: Function,
      required: true,
    },
    selectedItem: {
      type: Object,
      required: false,
    },
  },
  components: {
    Label,
  },
  data() {
    return {
      value: this.item_value,
      categoryName: this.$route.params.categoryName,
      layout: {
        single: {
          name: "single",
          value: "single",
          displayName: "Single Column",
          icon: "singlelayout.svg",
        },
        double: {
          name: "double",
          value: "double",
          displayName: "Double Column",
          icon: "doublelayout.svg",
        },
      },
    };
  },
  watch: {
    item_value: {
      handler(val) {
        this.value = val;
      },
      deep: true,
    },
    value(val) {
      this.updateValue(this.item_key, val);
    },
  },
};
</script>
<template>
  <div class="mb-3">
    <Label :item="item" />
    <div class="flex col-12 mt-2 radio-container">
      <div
        v-for="option in item.options"
        v-bind:key="option.name"
        class="form-check col-3"
      >
        <div>
          <img :src="require(`@/assets/images/${layout[option.name].icon}`)" />
        </div>
        <div class="checkbox-input">
          <input
            class="form-check-input"
            type="radio"
            v-model="value"
            v-bind:value="option"
            :disabled="
              categoryName == 'globalupdate'
                ? false
                : selectedItem.additionalProp1.global
                ? true
                : false
            "
          />
          <label class="form-check-label ml-2">{{
            layout[option.name].displayName || option.name
          }}</label>
        </div>
      </div>
    </div>

    <div v-if="submitted && validation.$error" class="invalid-feedback">
      <span v-if="!validation.required">This value is required.</span>
    </div>
  </div>
</template>
<style scoped>
.checkbox-input {
  padding-top: 20px;
  margin-left: 20px;
}
.checkbox-input .form-check-input {
  transform: scale(1.5);
  cursor: pointer;
  accent-color: #005eb8 !important;
}
.form-check {
  padding: 0px;
}
.radio-container {
  padding: 0px;
}
</style>
